import { Button, ButtonTheme, Tooltip } from 'lego-on-react';
import React from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/Common';
import block from 'propmods';

import { useCopy } from '../../hooks/useCopy';
import { Field } from '../Form/Form';

import './CopyField.scss';

const t = i18n(keyset);

interface Props {
    text: string;
    label: React.ReactNode;
    buttonLabel?: string;
    description?: React.ReactNode;
    caption?: React.ReactNode;
    border?: boolean;
    theme?: ButtonTheme;
    disabled?: boolean;
}

const b = block('CopyField');

const CopyField: React.SFC<Props> = (props) => {
    const {
        text,
        buttonLabel = t('to-copy'),
        description,
        label,
        caption,
        border = true,
        theme = 'normal',
        disabled,
    } = props;

    const { getTooltipProps, onButtonClick, onCodeClick, textRef, buttonRef } = useCopy();

    const tooltipProps = getTooltipProps();

    return (
        <div {...b()}>
            <Field name="code" label={label} caption={caption}>
                <div {...b('code', { border, disabled })} ref={textRef} onClick={disabled ? undefined : onCodeClick}>
                    {text}
                </div>
                <Button theme={theme} size="s" onClick={onButtonClick} ref={buttonRef} disabled={disabled}>
                    {buttonLabel}
                </Button>
                {tooltipProps.visible && (
                    <Tooltip {...tooltipProps} theme="white" autoclosable to="right" size="s">
                        {t('copied')}
                    </Tooltip>
                )}
                {description ? description : null}
            </Field>
        </div>
    );
};

export default CopyField;
